import {
    Box, Divider, Typography, Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    IconButton,
    CircularProgress,
    Button,
} from '@mui/material'
import EditIcon from '@mui/icons-material/Edit';

import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { Plus } from 'lucide-react';
import apiClient from '../../utils/apiClient';

const DisplayTaxConfig = () => {
    const [error, setError] = useState(null)
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()
    const [taxConfig, setTaxConfig] = useState([])
    const getTaxs = async () => {
        setLoading(true)
        try {
            const response = await apiClient.get('/extrafee/admin/extrafees');
            if (response?.data?.status === true) {
                setTaxConfig(response?.data?.fees)
            }

        } catch (error) {
            setError(error?.response?.data?.message)
        }
        finally {
            setLoading(false)
        }
    }
    const handleEditClick = (taxConfig) => {
         navigate('/create-edit-taxfee', { state: { taxConfig } })
    }
    const handleAddClick = () => {
        navigate('/create-edit-taxfee',)
    }
    useEffect(() => {
        getTaxs()
    }, [])

    return (
        <>
            <Box sx={{ backgroundColor: '', padding: 3 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                    <Typography variant="h3">Tax Config</Typography>
                    <Button
                        variant="contained"
                        sx={{ borderRadius: "8px", padding: "8px 20px", display: "flex", gap: 1 }}
                        onClick={handleAddClick}
                    >
                        <Plus size={23} />
                        <Typography>Add Tax</Typography>
                    </Button>
                </Box>
                <Divider sx={{ marginBottom: 3 }} />
                {loading ? (
                    <Box display="flex" justifyContent="center" alignItems="center" height="100px">
                        <CircularProgress />
                    </Box>
                ) : (
                    <TableContainer component={Paper} elevation={1}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell><strong>Name</strong></TableCell>
                                    <TableCell><strong>Description</strong></TableCell>
                                    <TableCell><strong>Fee Type</strong></TableCell>
                                    <TableCell><strong>Type</strong></TableCell>
                                    <TableCell><strong>Value</strong></TableCell>
                                    <TableCell><strong>Is Active</strong></TableCell>
                                    <TableCell align="right"><strong>Actions</strong></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {taxConfig.length === 0 ? (
                                    <TableRow>
                                        <TableCell colSpan={5} align="center">
                                            No deliveryRange found.
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    taxConfig.map((item) => (
                                        <TableRow key={item.id}>

                                            <TableCell>
                                                {item?.name}
                                            </TableCell>

                                            <TableCell>{item.description}</TableCell>
                                            <TableCell>{item.feeType}</TableCell>

                                            <TableCell>{item.type}</TableCell>
                                            <TableCell>{item.value}</TableCell>
                                            <TableCell>{item?.isActive === true ? 'true' : 'false'}</TableCell>
                                            <TableCell>
                                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'end', gap: 1 }}>
                                                    <IconButton onClick={() => handleEditClick(item)}>
                                                        <EditIcon />
                                                    </IconButton>

                                                </Box>
                                            </TableCell>
                                        </TableRow>
                                    ))
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
                {error && <Typography variant="body2" color="error">{error}</Typography>}
            </Box>
        </>
    )
}

export default DisplayTaxConfig
